import React, { useState, useEffect } from "react";
import { MdArrowForwardIos, MdArrowBackIos } from "react-icons/md";
import  './styles/Home.css';
import banner from '../assets/contact-banner.jpg';
import {Link} from 'react-router-dom';
const slides = [
  { label: "Innovative Manufacturing Solutions", img: "/images/slide1.jpg" },
  { label: "Quality Products", img: "/images/slide2.jpg" },
  { label: "Engineer Driven", img: "/images/slide3.jpg" }
];

export default function Home(){
    const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return (
   <div>
      {/* Slider Section */}
      <section className="slider-container">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`slide ${index === currentSlide ? "active" : ""}`}
          >
            <img src={slide.img} alt={slide.label} />
            <div className="slide-overlay"></div>
            <div className="slide-content">
              <div className="slide-subtitle">Precision & Excellence</div>
              <h1 className="slide-title">{slide.label}</h1>
            </div>
          </div>
        ))}
        <button
          onClick={() =>
            setCurrentSlide((currentSlide - 1 + slides.length) % slides.length)
          }
          className="slider-button left"
          aria-label="Previous slide"
        >
          <MdArrowBackIos />
        </button>
        <button
          onClick={() => setCurrentSlide((currentSlide + 1) % slides.length)}
          className="slider-button right"
          aria-label="Next slide"
        >
          <MdArrowForwardIos />
        </button>
      </section>

      {/* About Message */}
      <section className="intro-section text-center">
        <div className="container">
          <div className="intro-badge">Who We Are </div>
          <h2 className="intro-title"> Fabrication & Manufacturing</h2>
          <p className="intro-text">
            Reena Industries is dedicated to delivering precision-engineered fabrication and manufacturing solutions that meet the highest standards of quality, durability, and innovation. With years of hands-on experience, our expert team specializes in custom steel works, mechanical assembly, industrial painting, shot blasting, and metalizing services tailored to a wide range of industries.
          </p>
        </div>
      </section>

      {/* Call to Action */}
      <section className="banner-section">
        <img src={banner} alt="Get in Touch" className="banner-image"/>
        <div className="banner-overlay">
          <h2 className="banner-title">Get in touch with us Today</h2>
          <Link to='/contact' className="btn-custom">Contact Us</Link>
        </div>
      </section>

      {/* Map Embed */}
      <section className="container my-5 map-section-container">
        <div className="text-center mb-4">
          <h2 className="section-heading">Our Location</h2>
          <div className="section-separator"></div>
        </div>
        <div className="map-wrapper shadow">
          <iframe
            title="Reena Industries Location Map"
            src="https://maps.google.com/maps?q=Reena%20Industries%2C%206CC5%2BC92%2C%20Hathkhoj%2C%20Charoda%2C%20Chhattisgarh%20490021&t=&z=16&ie=UTF8&iwloc=&output=embed"
            className="map-iframe"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>

    </div>
  );
}

